import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import { RequestPayload } from './types';
import { User, UserPayload } from './models/user';
const ENDPOINT = 'user/';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getUsers: (payload: RequestPayload) =>
    instance.post<
      RequestPayload,
      AxiosResponse<ApiResponse<Paginated<'data', User>>>
    >(ENDPOINT + 'list/', payload, config),
  getUserByName: (username: string) =>
    instance.get<ApiResponse<User>>(`${ENDPOINT}${username}/`, config),
  create: (payload: UserPayload) =>
    instance.post(ENDPOINT + 'create/', payload, config),
  modify: (payload: UserPayload) =>
    instance.post(ENDPOINT + 'update/', payload, config),

  getPositions: (payload: RequestPayload) =>
    instance.post<
      RequestPayload,
      AxiosResponse<ApiResponse<Paginated<'data', EntityBase>>>
    >(ENDPOINT + 'position/list/', payload, config),
  createPosition: (payload: EntityBase) =>
    instance.post(ENDPOINT + 'position/create/', payload, config),
  modifyPosition: (payload: EntityBase) =>
    instance.put(ENDPOINT + 'position/update/', payload, config),
});
